import * as go from 'gojs';

import { HiddenCategory } from 'src/containers/ProjectDiagram/constants/categories';
import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import { setDiagramSelection } from 'src/containers/ProjectDiagram/utils/setDiagramSelection';

export const selectAttribute =
  (attributeIri: string, appendSelectionHistory?: boolean) =>
  (diagram: Diagram) => {
    const attribute = diagram.model.modelData.attributesByIri[attributeIri];
    if (!attribute) {
      return;
    }
    const { hiddenPart } = diagram;
    hiddenPart.setValue({
      value: attribute.value,
      category: HiddenCategory.MODEL_CONCEPT_ATTRIBUTE,
    });
    const selection = new go.Set([hiddenPart]);
    setDiagramSelection(selection, appendSelectionHistory)(diagram);
  };
